export default {"src":"/_next/static/media/checkmarkDoc.1dcd64e9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};